import { TextareaAutosize } from '@mui/material'

const Textarea = ({ formData, handleChange, ...rest }) => {
  const { style, ...restProps } = rest

  return (
    <TextareaAutosize
      {...formData}
      minRows={3}
      style={{
        resize: 'none',
        background: 'transparent',
        borderRadius: '12px',
        ...style,
      }}
      onChange={handleChange}
      {...restProps}
    />
  )
}

export { Textarea }
